<template>
  <div v-if="showStatus" class="action-error-block d-flex align-center pa-5" :class="{ 'action-error-block__full': errorFull || forceErrorFull }">
    <funnow-icon class="mr-3" max-width="28" height="28" :image-path="`alert-circle${errorFull || forceErrorFull ? '' : '-outline'}.svg`" />
    <span v-html="errorMessage" />

    <v-spacer />

    <v-btn v-if="closedIcon" class="close-btn" :min-width="24" :width="24" :height="24" variant="text" @click="hide">
      <v-icon :size="20" :color="errorFull || forceErrorFull ? 'white' : 'red50'"> mdi-close </v-icon>
    </v-btn>
  </div>
</template>

<script>
import FunnowIcon from '@/components/icons/funnow-icon'

export default {
  name: 'DialogError',
  components: {
    FunnowIcon,
  },
  props: {
    showStatus: { type: Boolean, default: false },
    error: { type: [String, Object, Error], default: '' },
    closedIcon: { type: Boolean, default: false },
    forceErrorFull: { type: Boolean, default: false },
  },
  emits: ['update:showStatus'],
  data() {
    return {
      errorFull: false,
    }
  },
  computed: {
    errorMessage() {
      return typeof this.error === 'string' ? this.error : this.error.message
    },
  },
  watch: {
    error: {
      handler(errorData) {
        this.errorFull = errorData.code === 'offline'
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    hide() {
      this.$emit('update:showStatus', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.action-error-block {
  border: 1px solid $red50;
  color: $red50;
  border-radius: 4px;

  &__full {
    background-color: $red50;
    color: white;
  }
}

.dialog-error {
  position: fixed;
  bottom: 100px;
  z-index: 999;
  left: 50%;
  transform: translateX(-50%);
  min-width: 380px;
}
</style>
